export default __webpack_public_path__ + "static/media/banner.f47b31fd.svg";